module.exports = {
      id: "scissors-usage",
      viewBox: "0 0 380.621 380.62",
      url: __webpack_public_path__ + "assets/sprite-28816f.svg#scissors-usage",
      toString: function () {
        return this.url;
      }
    }